import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import activityNotesService from "../services/activity-notes-services";

export const caseActivityNoteSearchQuery = z.object({
	case_activity_id: z.string(),
	per_page: z.number().optional(),
	page: z.number().nullable().optional(),
});

export const caseActivityNoteQueryOptions = (search?: z.infer<typeof caseActivityNoteSearchQuery>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["case_activity_note", search],
		queryFn: () => activityNotesService.list(transformSearch(search, ["case_activity_id"])),
		...options,
	});
};

export const useActivityNoteMutation = (caseActivityNoteId?: string) => {
	return useMutation({
		mutationKey: ["case_activity_note", caseActivityNoteId],
		mutationFn: activityNotesService.upsertById,
		meta: {
			successMessage: "Note saved successfully",
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["case_activity_note"] });
		},
	});
};

export const useActivityNoteDeleteMutation = () => {
	return useMutation({
		mutationKey: ["case_activity_note", "delete"],
		mutationFn: activityNotesService.deleteById,
		meta: {
			successMessage: "Note archived successfully",
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["case_activity_note"],
			});
		},
	});
};
